const ROUTES = {
  "/": {
    "name": "HomePageDb47151dC8ce483eBdd8F04dadabb61c",
    "type": "HTML",
    "key": "home-page"
  },
  "/_admin/*": {
    "name": "AdminPages9147cb141940475590fb2a8679bd6409",
    "type": "HTML",
    "key": "admin-pages"
  },
  "/about": {
    "name": "AboutUsPage09b837a8Af494859A4a7Dffb76f18f3e",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/leveling": {
    "name": "AboutLevelingPageA5ddd4b7Ba7f4735A4297a449ece0334",
    "type": "HTML",
    "key": "about-leveling-page"
  },
  "/about/offerings": {
    "name": "AboutOfferings5c0d118762794370Bd5aA4682f2be444",
    "type": "HTML",
    "key": "about-offerings"
  },
  "/about/susan": {
    "name": "AboutSusan507792578d2747c2A9b24431370d4865",
    "type": "HTML",
    "key": "about-susan"
  },
  "/events/public": {
    "name": "PublicEventsPageA8475aa2Dc804f1e871362bfc4a29b72",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage69aad7faFfa544759daf462bae21f146",
    "type": "REFERENCE",
    "key": "join-us-page"
  },
  "/members-old/*": {
    "name": "MemberPagesOldD13eadd8A55740c687c77e12a6aa3b39",
    "type": "HTML",
    "key": "member-pages-old"
  },
  "/members/messages/*": {
    "name": "MessagePagesC37d6664417945ddA3d1B43b3612995a",
    "type": "HTML",
    "key": "message-pages"
  },
  "/resources": {
    "name": "ResourcesPage769bf0842c3a420bB2bf318376630914",
    "type": "REFERENCE",
    "key": "resources-page"
  },
  "/signup/*": {
    "name": "SignupPages3a700b3eC55246c58fc1E625486e3bb6",
    "type": "REFERENCE",
    "key": "signup-pages"
  }
};

export default ROUTES;